export const coresAmbientes = [
    "#fdab3d", "#00c875", "#e2445c", "#0086c0", "#579bfc", "#a25ddc", "#037f4c", "#cab641", "#ffcb00", "#333333",
    "#6e8b3d", "#02659a", "#63c8a8", "#10a1ff", "#bcee68", "#ff7373", "#9fd5d0", "#8b8b83", "#9999ff"
]